import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';



import { useDispatch, useSelector } from 'react-redux';

import classes from "../Sigfox/SigfoxModalForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addCamectAPI, addSigfoxAPI, linkGateway, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';

const SigfoxIDReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }
    //otherwise
    return { value: '', isValid: false };
}

const POWER_OPTIONS = [
    { label: 'Solar panel', value: 'solar' },
    { label: 'Mains powered', value: 'mains' },
    { label: 'Battery only', value: 'battery' },
];


const GatewayModalForm = ({ setShowVirtualSource, inputs, virtualType, fetchVirtualSources, setShowSuccess }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);


    const apiData = {
        token,
        client
    }

    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(1);

    const [pinSelected, setPinSelected] = useState(null)
    const [poweredBy, setPoweredBy] = useState(null);

    //------------------------------- Modal Logic  ----------------------------------------------

    const ModalDialog = useRef();

    // call ref to clearStates method from child component ScheduledAction.
    const ClearStatesChildComponetRef = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();

        HandelResetModal();
    }
    //-------------------------------------------------------------------------------------------------

    // reset model when Escape key is pressed
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                // Handle the Escape key press here
                HandelResetModal();
            }
        };

        // Add event listener when component mounts
        document.addEventListener('keydown', handleKeyDown);


        // Clean up event listener when component unmounts
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const [formIsValid, setFormIsValid] = useState(false);

    const [sigFoxIDState, dispatchSigFoxIDState] = useReducer(SigfoxIDReducer, {
        value: '',
        isValid: null
    });

    const sigfoxIDInputRef = useRef();

    const { isValid: sigfoxIDIsValid } = sigFoxIDState;

    useEffect(() => {
        const identifier = setTimeout(() => {
            setFormIsValid(sigfoxIDIsValid)
        }, 500);

        return () => {
            clearTimeout(identifier);
        };
    }, [sigfoxIDIsValid]);

    const sigfoxIDChangeHandler = (event) => {
        dispatchSigFoxIDState({ type: 'USER_INPUT', val: event.target.value });
    }

    const validateSigfoxIDHandler = () => {
        dispatchSigFoxIDState({ type: 'INPUT_BLUR' });
    }


    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const onClearHandler = () => {
        dispatchSigFoxIDState({ type: 'INPUT_CLEAR', val: "" })
    }

    const dispatch = useDispatch();

    const advanceToPageTwo = (event) => {
        event.preventDefault();
        setModalPageIndex(2);
    };

    const submitHandler = async (selectedPower) => {
        const gatewayDetails = {
            gatewayIMEI: sigFoxIDState.value,
            siteUUID: DeviceUUID,
            name: "",
            poweredBy: selectedPower
        }
        const responseData = await linkGateway(apiData, gatewayDetails, dispatch)
        if (responseData && responseData.success) {
            HandleCloseModal();
            fetchVirtualSources();
            setShowSuccess(true);
        }
    };

    useEffect(() => {
        switch (modalPageIndex) {
            case 1:
                setModalComponent(
                    <form onSubmit={advanceToPageTwo} className={classes["container"]} method="dialog">
                        <ul className={classes["inputs-list"]}>
                            <li className={classes["input-container"]}>
                                <label className={classes.subTitle}>Enter the gateway IMEI below</label>
                                <Input
                                    className={classes.input}
                                    placeholder={"Gateway IMEI"}
                                    ref={sigfoxIDInputRef}
                                    id="CamectIP"
                                    type={"text"}
                                    isValid={sigFoxIDState.isValid}
                                    value={sigFoxIDState.value}
                                    onChange={sigfoxIDChangeHandler}
                                    onBlur={validateSigfoxIDHandler}
                                />

                            </li>
                        </ul>

                        <br/>
                        <Button icon="pi pi-arrow-right" type='submit' label="Next" severity='success' disabled={!formIsValid}/>

                    </form>
                )
                HandleShowModal();
                break;
            case 2:
                setModalComponent(
                    <div className={classes["container"]}>
                        <ul className={classes["inputs-list"]}>
                            <li className={classes["input-container"]}>
                                <label className={classes.subTitle}>How will the gateway be powered?</label>
                                <div className={classes["power-options"]}>
                                    {POWER_OPTIONS.map(option => (
                                        <div
                                            key={option.value}
                                            className={`${classes["power-option"]} ${poweredBy === option.value ? classes["power-option--selected"] : ''}`}
                                            onClick={() => setPoweredBy(option.value)}
                                        >
                                            {option.label}
                                        </div>
                                    ))}
                                </div>
                            </li>
                        </ul>

                        <br/>
                        <Button icon="pi pi-save" type='button' label="Save" severity='success' disabled={!poweredBy} onClick={() => submitHandler(poweredBy)}/>
                    </div>
                )
                break;
        }
    }, [modalPageIndex, sigFoxIDState, poweredBy, formIsValid]); // Empty dependency array ensures it runs only once after initial render



    const CreateSchedule = async (body) => {

        // const response = await createScheduleApi(apiData, body, dispatch);
        // if (response && response.success) {
        //     HandleCloseModal();
        //     fetchAutomations();
        // }

    }

    return (
        <>
            <Modal ref={ModalDialog} title={"Add gateway"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default GatewayModalForm;
